
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

export const BlockParty = () => {
    

    const ContentWrap = styled.div`
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4rem;
    `;
    const CenterLink = styled.a`
        text-align: center;
    `;

    return (
        <>
            <Helmet>
                <title>Shekhar Khedekar</title>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
            </Helmet>

            <ContentWrap>
                <CenterLink 
                    href="https://docs.google.com/spreadsheets/d/1-HrNKgRGFrNy20oq1zdB21-nhserDYTmRxJG8DmqCfA/edit?usp=sharing">
                    Click here to RSVP and sign up for the Garfield Block Party Pot Luck
                </CenterLink>
            </ContentWrap>
        </>
    );
};
